import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "regenerator-runtime/runtime.js";
import { computed, defineComponent, ref, watch, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import GridsListing from "@/components/layout/cards-container/GridsListing.vue";
import Payment from "./components/Payment.vue";
import CompleteOrder from "./components/CompleteOrder.vue";
import POSConfigModule from "@/store/modules/pos-config";
import BookingModule from "@/store/modules/booking";
import { BookingStep } from "@/constants/booking";
import { ElMessageBox } from "element-plus";
import { PSBErrors } from "@/constants/errors/product-slot-booking";
import { saveUpdatedBooking } from "@/db/updated-bookings";
import { SyncType } from "@/interfaces/store/IBooking";
import { AccountingState, PaymentMethods, PaymentTool, PromocodeCampaignType, TransactionTypes } from "@/types/db/accounting";
import { BookingState } from "@/types/db/product-slot-booking";
import ScannerModule from "@/store/modules/scanner";
import { addScannedProductToBasket } from "@/utils/helpers/scanner";
import { createTicketAccountings } from "@/utils/vue-helpers/accounting";
import { Currencies } from "@/constants/currency";
import { hasSalesStarted } from "@/utils/vue-helpers/cash-float";
import { LogService } from "@/services/logging";
import { startProcessing, buildPatchBookingPayload, compareTwoObjects, autoPrintTicket, printLabels, handlePendingPaymentsCheck, syncPromocodeBookingAsPending } from "@/utils/vue-helpers/booking";
import { saveUntypedBooking } from "@/db/untyped-booking";
import PrinterConfigModule from "@/store/modules/printers-config";
import { bookingTotalConsideringDiscounts, failAllPendingCodeAccountings, restToPay } from "@/utils/vue-helpers/new-accountings";
import { cloneDeep } from "lodash";
import { endTransaction, signAustriaReceipt, startAndCompleteItalyOrder } from "@/utils/helpers/fiskaly";
import { setCustomerInfo } from "@/utils/helpers/product-slot-booking";
import AppModule from "@/store/modules/app";
import NotificationService from "@/services/notification.service";
import i18n from "@/lang";
import { getUntypedBookingByUuid, isBookingInDexie } from "@/utils/helpers/booking";
import { PaymentMethodTypes } from "@/types/db/pos-config";
import { processAbortEvent, processSaleEvent } from "@/utils/helpers/compliance";
export default defineComponent({
  name: "Booking",
  components: {
    GridsListing: GridsListing,
    Payment: Payment,
    CompleteOrder: CompleteOrder
  },
  setup: function setup() {
    // creating a reference to the component CustomerSeatingChart
    // so that we can trigger CustomerSeatingChart.selectObjects() & CustomerSeatingChart.deselectObjects() functions
    var completeOrder = ref(null);

    var _useI18n = useI18n({
      useScope: "global"
    }),
        t = _useI18n.t;

    var msg = ref("");
    var isLoading = ref(false);
    var hasSelectedConfig = ref(false);
    var ScannerTog = computed(function () {
      return ScannerModule.tog;
    });
    watch(ScannerTog, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _completeOrder$value;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log("---- hi from scanner watch");

              if (!(ScannerModule.value && ScannerModule.singleListenerOnly)) {
                _context.next = 15;
                break;
              }

              if (!(BookingModule.bookingStep === BookingStep.CompleteOrder)) {
                _context.next = 12;
                break;
              }

              // We create a new booking and select it, then add a product to it
              console.log("------ in completed ui going to create a new booking, select it, and add scanned item to basket"); // console.log("completeOrder")
              // console.log(completeOrder)

              _context.next = 6;
              return (_completeOrder$value = completeOrder.value) === null || _completeOrder$value === void 0 ? void 0 : _completeOrder$value.endBooking();

            case 6:
              console.log("----- done ending the booking");
              console.log("------- calling addScannedProductToBasket");
              _context.next = 10;
              return addScannedProductToBasket(ScannerModule.value);

            case 10:
              _context.next = 15;
              break;

            case 12:
              // Not in completed ui, lets add an item to the basket
              console.log("------ not in completed ui, adding scanned item to the basket");
              _context.next = 15;
              return addScannedProductToBasket(ScannerModule.value);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), {
      deep: true
    });
    var hasTickets = computed(function () {
      return BookingModule.hasTickets;
    });
    var selectedBookingUUID = computed(function () {
      return BookingModule.selectedBookingUUID;
    });
    var step = computed(function () {
      return BookingModule.bookingStep;
    });
    var isEnabled1 = computed(function () {
      var _BookingModule$select, _BookingModule$select2, _BookingModule$select3, _BookingModule$applie;

      if (
      /* user can go forcard if he booked tickets */
      hasTickets.value && step.value === BookingStep.Order &&
      /* user pulled paid booking from backend */
      (isEditOrder.value && restToPay.value === 0 && step.value === BookingStep.Order) !== true) {
        return true;
      } // console.log("@@@@@@@BookingModule.selectedBookingPayment");
      // console.log(BookingModule.selectedBookingPayment);
      // console.log(
      //   "@@@@@@@@BookingModule.selectedBookingPayment?.paymentToolId"
      // );
      // console.log(BookingModule.selectedBookingPayment?.paymentToolId);


      if (restToPay.value > 0 && BookingModule.selectedBookingPayment && ((_BookingModule$select = BookingModule.selectedBookingPayment) === null || _BookingModule$select === void 0 ? void 0 : _BookingModule$select.paymentToolId) === PaymentMethods.EXTERNAL_INCERT_VOUCHER) {
        return false;
      }

      if ((restToPay.value / 100 <= BookingModule.confirmedAmountsTotal || BookingModule.doesSupportSplitPayment && BookingModule.splitAmount && BookingModule.confirmedAmountsTotal || canConfirm.value
      /* user can click complete order if it's a card or he entered a cash amount and applied its payment */
      ) && step.value === BookingStep.Payment
      /* user can complete the booking if its fully discounted */
      ) {
        return true;
      }

      if (restToPay.value === 0 && (step.value === BookingStep.Payment || step.value === BookingStep.Discount || step.value === BookingStep.Promocode || step.value === BookingStep.PromocodeCampaigns || step.value === BookingStep.Offers || BookingModule.selectedBookingPayment && ((_BookingModule$select2 = BookingModule.selectedBookingPayment) === null || _BookingModule$select2 === void 0 ? void 0 : _BookingModule$select2.paymentToolId) !== PaymentMethods.EXTERNAL_INCERT_VOUCHER)) {
        return true;
      }

      if (
      /* user can complete booking if he applied a refund */
      step.value === BookingStep.Refund && restToPay.value === 0) {
        return true;
      }

      if (
      /** Enable user to print a booking that he pulled from backend */
      isEditOrder.value && restToPay.value === 0 && ((_BookingModule$select3 = BookingModule.selectedBooking) === null || _BookingModule$select3 === void 0 ? void 0 : _BookingModule$select3.state) === BookingState.Completed) {
        return true;
      }

      if (restToPay.value === 0 && BookingModule.isPromocodeApplied && BookingModule.appliedPromocode && [PromocodeCampaignType.TYPE_VOUCHER, PromocodeCampaignType.TYPE_VOUCHER_SOLD, PromocodeCampaignType.TYPE_GIFT_CARD, PromocodeCampaignType.TYPE_GIFT_CARD_SOLD].includes((_BookingModule$applie = BookingModule.appliedPromocode) === null || _BookingModule$applie === void 0 ? void 0 : _BookingModule$applie.promocode.promoCodeType)) {
        return true;
      }

      return false;
    });
    var amountsTrack = computed(function () {
      return BookingModule.bookingsAmountsTrack[selectedBookingUUID.value];
    });
    var currentPaymentTool = computed(function () {
      if (!amountsTrack.value) return PaymentTool.None;
      return amountsTrack.value.paymentTool;
    });
    var currentPaymentToolId = computed(function () {
      if (!amountsTrack.value) return null;
      return amountsTrack.value.paymentToolId;
    });
    var selectedCashCurrency = computed(function () {
      return BookingModule.selectedCashCurrency;
    });
    var canConfirm = computed(function () {
      if (!amountsTrack.value) return false;
      return currentPaymentTool.value === PaymentTool.Cash || currentPaymentTool.value === PaymentTool.CardAuto || currentPaymentTool.value === PaymentTool.CardManual || currentPaymentTool.value === PaymentTool.BankTransfer || currentPaymentTool.value === PaymentTool.Invoice || currentPaymentTool.value === PaymentTool.ToBeInvoiced || currentPaymentTool.value === PaymentTool.Cheque || currentPaymentTool.value === PaymentTool.ChequeVacances || currentPaymentTool.value === PaymentTool.ChequeCulture || currentPaymentTool.value === PaymentTool.PassCulture || currentPaymentTool.value === PaymentTool.Chorus || currentPaymentTool.value === PaymentTool.CE || currentPaymentTool.value === PaymentTool.OCCYG || currentPaymentTool.value === PaymentTool.CouponSport || currentPaymentTool.value === PaymentTool.PosReka || currentPaymentTool.value === PaymentTool.DiverseVoucher || currentPaymentTool.value === PaymentTool.CFF || currentPaymentTool.value === PaymentTool.CGN || currentPaymentTool.value === PaymentTool.QOQA || currentPaymentTool.value === PaymentTool.DEINDEAL || currentPaymentTool.value === PaymentTool.REALDEAL || currentPaymentTool.value === PaymentTool.EXTERNAL_INCERT_VOUCHER || currentPaymentTool.value === PaymentTool.Swiss_QR_Code_Bank_Transfer || currentPaymentTool.value === PaymentTool.BuyClub || currentPaymentTool.value === PaymentTool.POS_BIMPLI_CADO || currentPaymentTool.value === PaymentTool.POS_KADEOS_INFINI || currentPaymentTool.value === PaymentTool.POS_ANCV_CONNECT || currentPaymentTool.value === PaymentTool.TOUT_UN_CANTON || currentPaymentTool.value === PaymentTool.CHAPLINS || currentPaymentTool.value === PaymentTool.HELLO_CSE || currentPaymentToolId.value === PaymentMethodTypes.Cash || currentPaymentToolId.value === PaymentMethodTypes.CardManual || currentPaymentToolId.value === PaymentMethodTypes.CardAuto || currentPaymentToolId.value === PaymentMethodTypes.BankTransfer || currentPaymentToolId.value === PaymentMethodTypes.Invoice || currentPaymentToolId.value === PaymentMethodTypes.ToBeInvoiced || currentPaymentToolId.value === PaymentMethodTypes.Cheque || currentPaymentToolId.value === PaymentMethodTypes.ChequeVacances || currentPaymentToolId.value === PaymentMethodTypes.chequeCulture || currentPaymentToolId.value === PaymentMethodTypes.passCulture || currentPaymentToolId.value === PaymentMethodTypes.chorus || currentPaymentToolId.value === PaymentMethodTypes.CE || currentPaymentToolId.value === PaymentMethodTypes.OCCYG || currentPaymentToolId.value === PaymentMethodTypes.CouponSport || currentPaymentToolId.value === PaymentMethodTypes.PosReka || currentPaymentToolId.value === PaymentMethodTypes.DiverseVoucher || currentPaymentToolId.value === PaymentMethodTypes.CFF || currentPaymentToolId.value === PaymentMethodTypes.CGN || currentPaymentToolId.value === PaymentMethodTypes.QOQA || currentPaymentToolId.value === PaymentMethodTypes.DEINDEAL || currentPaymentToolId.value === PaymentMethodTypes.REALDEAL || currentPaymentToolId.value === PaymentMethodTypes.EXTERNAL_INCERT_VOUCHER || currentPaymentToolId.value === PaymentMethodTypes.Swiss_QR_Code_Bank_Transfer || currentPaymentToolId.value === PaymentMethodTypes.BuyClub || currentPaymentToolId.value === PaymentMethodTypes.POS_BIMPLI_CADO || currentPaymentToolId.value === PaymentMethodTypes.POS_KADEOS_INFINI || currentPaymentToolId.value === PaymentMethodTypes.POS_ANCV_CONNECT || currentPaymentToolId.value === PaymentMethodTypes.TOUT_UN_CANTON || currentPaymentToolId.value === PaymentMethodTypes.CHAPLINS || currentPaymentToolId.value === PaymentMethodTypes.HELLO_CSE;
    });
    var total = computed(function () {
      return bookingTotalConsideringDiscounts.value;
    });
    var whatIsLeftToPay = computed(function () {
      return (restToPay.value / 100).toFixed(2);
    });
    var whatIsLeftToPayConverted = computed(function () {
      var _selectedCashCurrency;

      return (restToPay.value / 100 * (((_selectedCashCurrency = selectedCashCurrency.value) === null || _selectedCashCurrency === void 0 ? void 0 : _selectedCashCurrency.exchangeRate) || 1)).toFixed(2);
    });
    var selectedBooking = computed(function () {
      return BookingModule.selectedBooking;
    });
    var isEditOrder = ref(false);
    watchEffect( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!BookingModule.selectedBookingUUID) {
                _context2.next = 4;
                break;
              }

              _context2.next = 3;
              return isBookingInDexie(BookingModule.selectedBookingUUID);

            case 3:
              isEditOrder.value = _context2.sent;

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    var currency = computed(function () {
      var _selectedCashCurrency2, _BookingModule$select4;

      return ((_selectedCashCurrency2 = selectedCashCurrency.value) === null || _selectedCashCurrency2 === void 0 ? void 0 : _selectedCashCurrency2.label) || ((_BookingModule$select4 = BookingModule.selectedBooking) === null || _BookingModule$select4 === void 0 ? void 0 : _BookingModule$select4.currency) || Currencies.CHF;
    });
    var bookingButtonText = computed(function () {
      var booking = BookingModule.selectedBooking;

      if (!booking) {
        return;
      }

      if (hasTickets.value) {
        var _BookingModule$applie2;

        if (step.value === BookingStep.Order && !BookingModule.isFreeBooking) {
          return "".concat(t("button.continue-to-payment"), " | ").concat(currency.value, " ").concat(whatIsLeftToPayConverted.value);
        }

        if (step.value === BookingStep.Refund) {
          return t("button.complete-order");
        }

        if (restToPay.value
        /*BookingModule.leftToPayAmount*/
        === 0 && BookingModule.isPromocodeApplied && BookingModule.appliedPromocode && [PromocodeCampaignType.TYPE_VOUCHER, PromocodeCampaignType.TYPE_VOUCHER_SOLD, PromocodeCampaignType.TYPE_GIFT_CARD, PromocodeCampaignType.TYPE_GIFT_CARD_SOLD].includes((_BookingModule$applie2 = BookingModule.appliedPromocode) === null || _BookingModule$applie2 === void 0 ? void 0 : _BookingModule$applie2.promocode.promoCodeType)) {
          return "".concat(t("button.complete-order"), " | ").concat(currency.value, " ").concat(whatIsLeftToPayConverted.value);
        }

        if (step.value === BookingStep.Payment || step.value === BookingStep.Discount || step.value === BookingStep.Promocode || step.value === BookingStep.PromocodeCampaigns || step.value === BookingStep.Offers || restToPay.value
        /*BookingModule.pssSumFinaValues*/
        === 0) {
          if (BookingModule.doesSupportSplitPayment && BookingModule.splitAmount) {
            var splitAmountProvided = BookingModule.splitAmount.splitAmountProvided;

            if (currentPaymentTool.value === PaymentTool.Cash && selectedCashCurrency.value) {
              splitAmountProvided = splitAmountProvided * selectedCashCurrency.value.exchangeRate;
            }

            return "".concat(t("button.confirm-payment"), " | ").concat(currency.value, " ").concat(splitAmountProvided.toFixed(2));
          } else {
            var amount = Number(whatIsLeftToPay.value);

            if (currentPaymentTool.value === PaymentTool.Cash) {
              var _selectedCashCurrency3;

              amount = amount * (((_selectedCashCurrency3 = selectedCashCurrency.value) === null || _selectedCashCurrency3 === void 0 ? void 0 : _selectedCashCurrency3.exchangeRate) || 1);
            }

            return "".concat(t("button.complete-order"), " | ").concat(currency.value, " ").concat(amount.toFixed(2));
          }
        }
      }

      return t("button.select-product-to-continue");
    });
    hasSelectedConfig.value = Boolean(POSConfigModule.selectedConfig);
    var showSyncButton = computed(function () {
      return POSConfigModule.completeBookingWithBalance && restToPay.value
      /*BookingModule.leftToPayAmount*/
      !== 0;
    });
    var isAcompteBooking = computed(function () {
      return BookingModule.isAcompteBooking;
    });
    var promocodeBeingChecked = computed(function () {
      return BookingModule.promocodeBeingChecked;
    });
    return {
      t: t,
      msg: msg,
      hasSelectedConfig: hasSelectedConfig,
      hasTickets: hasTickets,
      isEnabled1: isEnabled1,
      isLoading: isLoading,
      step: step,
      bookingButtonText: bookingButtonText,
      BookingStep: BookingStep,
      selectedBookingUUID: selectedBookingUUID,
      total: total,
      currency: currency,
      selectedBooking: selectedBooking,
      isEditOrder: isEditOrder,
      hasSalesStarted: hasSalesStarted,
      showSyncButton: showSyncButton,
      isAcompteBooking: isAcompteBooking,
      startProcessing: startProcessing,
      buildPatchBookingPayload: buildPatchBookingPayload,
      compareTwoObjects: compareTwoObjects,
      promocodeBeingChecked: promocodeBeingChecked,
      completeOrder: completeOrder
    };
  },
  methods: {
    cancelOrder: function cancelOrder() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var booking, _yield$handlePendingP, canClose, promptedForConfirmation, confirmation;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                booking = BookingModule.selectedBooking;

                if (booking) {
                  _context3.next = 3;
                  break;
                }

                throw new Error(PSBErrors.NoBookingInModule);

              case 3:
                _context3.next = 5;
                return handlePendingPaymentsCheck(booking);

              case 5:
                _yield$handlePendingP = _context3.sent;
                canClose = _yield$handlePendingP.canClose;
                promptedForConfirmation = _yield$handlePendingP.promptedForConfirmation;

                if (canClose) {
                  _context3.next = 10;
                  break;
                }

                return _context3.abrupt("return");

              case 10:
                if (promptedForConfirmation) {
                  _context3.next = 25;
                  break;
                }

                _context3.next = 13;
                return new Promise(function (resolve) {
                  ElMessageBox.confirm("".concat(_this.t("cancel-order.message")), "".concat(_this.t("cancel-order.cancel-order")), {
                    confirmButtonText: "".concat(_this.t("button.confirm")),
                    cancelButtonText: "".concat(_this.t("button.cancel")),
                    type: "warning"
                  }).then(function () {
                    resolve(true);
                  }).catch(function () {
                    resolve(false);
                  });
                });

              case 13:
                confirmation = _context3.sent;

                if (confirmation) {
                  _context3.next = 16;
                  break;
                }

                return _context3.abrupt("return");

              case 16:
                if (!BookingModule.currentOrderSessionId) {
                  _context3.next = 25;
                  break;
                }

                _context3.prev = 17;
                _context3.next = 20;
                return processAbortEvent(booking, BookingModule.currentOrderSessionId);

              case 20:
                _context3.next = 25;
                break;

              case 22:
                _context3.prev = 22;
                _context3.t0 = _context3["catch"](17);
                LogService.info("Error processing ABORT event", {
                  error: _context3.t0
                });

              case 25:
                LogService.info("Cancelling the booking: ".concat(String(_this.selectedBookingUUID)));
                _this.isLoading = false;
                _context3.next = 29;
                return BookingModule.clearBooking();

              case 29:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[17, 22]]);
      }))();
    },
    fillBooking: function fillBooking() {
      // If there is no booking and we have everything to create a booking (config selected and PSCs pulled) then lets create a new booking
      var bookingsCount = Object.values(BookingModule.bookings).length; // the below variable is true if pos config is selected

      var canCreate = POSConfigModule.selectedConfig;

      if (bookingsCount === 0 && canCreate) {
        // We need to keep the same UI for the user, to do so we need to create a new booking for the user after app update
        LogService.info("App mounted without no bookings, going to create a new booking since there is none");
        BookingModule.createNewBooking();
      }
    },
    confirmSyncPartiallyPaidBooking: function confirmSyncPartiallyPaidBooking() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var msg;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                msg = "".concat(_this2.t("partially-paid-booking.balance"), " <b> ").concat(_this2.currency + " " + (restToPay.value
                /*BookingModule.leftToPayAmount*/
                / 100).toFixed(2), " </b>, <br>\n        ").concat(_this2.t("partially-paid-booking.confirm"), ".");
                _context4.next = 4;
                return ElMessageBox.confirm("", "".concat(_this2.t("order.confirm")), {
                  confirmButtonText: "".concat(_this2.t("button.confirm")),
                  cancelButtonText: "".concat(_this2.t("button.cancel")),
                  type: "warning",
                  message: msg,
                  dangerouslyUseHTMLString: true,
                  customClass: "custom-message-box"
                });

              case 4:
                LogService.info("User confirmed synching of partially paid booking: ".concat(_this2.selectedBookingUUID));
                _context4.next = 7;
                return _this2.syncPartiallyPaidBooking();

              case 7:
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](0);
                console.error("Sync order cancelation");

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 9]]);
      }))();
    },
    syncPartiallyPaidBooking: function syncPartiallyPaidBooking() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _yield$getUntypedBook;

        var bookingCopy, _yield$syncPromocodeB, success, translatedMsg, syncedBooking, diffObject, result;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(!BookingModule.selectedBooking || !BookingModule.selectedBooking.uuid)) {
                  _context5.next = 2;
                  break;
                }

                throw new Error(PSBErrors.NoBookingInModule);

              case 2:
                bookingCopy = cloneDeep(BookingModule.selectedBooking); // if it's a promocode booking, check if it's possible to continue syncing

                _context5.next = 5;
                return syncPromocodeBookingAsPending();

              case 5:
                _yield$syncPromocodeB = _context5.sent;
                success = _yield$syncPromocodeB.success;
                translatedMsg = _yield$syncPromocodeB.translatedMsg;

                if (success) {
                  _context5.next = 12;
                  break;
                }

                if (translatedMsg) {
                  // the error was promocode related
                  NotificationService.showCustomError(translatedMsg); // cancel promocode accountings

                  failAllPendingCodeAccountings(bookingCopy);
                  BookingModule.updateBooking(bookingCopy);
                } else {
                  NotificationService.showCustomError(i18n.global.t("promocode.couldnt-process"));
                }

                AppModule.updatedIsLoading(false);
                return _context5.abrupt("return");

              case 12:
                // Create ticket type accountings for the booking
                // TODO POS: Below, before creating TICKET type accountings we need to check whether a PSS has already TICKET type accounting or not yet.
                createTicketAccountings(BookingModule.selectedBooking).forEach(function (ticketAcc) {
                  bookingCopy.accountings.push(ticketAcc);
                });
                BookingModule.updateBooking(bookingCopy); // Create/Update TAX accounting for the booking
                // updateTaxAccounting();
                // TODO POS: If the booking has generic discount accountings, or discount codes accountings, or payment codes accountings
                // then they are in Pending state and we need to confirm them before moving the booking to backend

                _context5.next = 16;
                return _this3.completeCodeAccountings();

              case 16:
                _context5.next = 18;
                return BookingModule.completeSelectedBooking();

              case 18:
                // save customer info
                setCustomerInfo(bookingCopy); // Save the diff and the booking in its final shape in DB

                _context5.next = 21;
                return getUntypedBookingByUuid(bookingCopy.uuid);

              case 21:
                _context5.t1 = _yield$getUntypedBook = _context5.sent;
                _context5.t0 = _context5.t1 === null;

                if (_context5.t0) {
                  _context5.next = 25;
                  break;
                }

                _context5.t0 = _yield$getUntypedBook === void 0;

              case 25:
                if (!_context5.t0) {
                  _context5.next = 29;
                  break;
                }

                _context5.t2 = void 0;
                _context5.next = 30;
                break;

              case 29:
                _context5.t2 = _yield$getUntypedBook.booking;

              case 30:
                syncedBooking = _context5.t2;
                console.log("----------- L3-5711 checking if synchedOriginalBooking from Booking.vue");
                console.log(syncedBooking);

                if (!syncedBooking) {
                  _context5.next = 45;
                  break;
                }

                console.log("----------- L3-5711 we are going to build diff object buildPatchBookingPayload() and then call saveUpdatedBooking()"); // this booking is synced previously, so let's save the diff object

                diffObject = buildPatchBookingPayload(syncedBooking, BookingModule.selectedBooking);
                _context5.prev = 36;
                _context5.next = 39;
                return saveUpdatedBooking(diffObject);

              case 39:
                //add booking uuid to the list of synced bookings if it is not edited booking
                BookingModule.storeBookingInPendingSyncBookings({
                  bookingUUID: BookingModule.selectedBooking.uuid,
                  type: SyncType.PUT
                });
                _context5.next = 45;
                break;

              case 42:
                _context5.prev = 42;
                _context5.t3 = _context5["catch"](36);
                LogService.info("Error when saving the booking diff object to indexedDB, booking: ".concat(bookingCopy.uuid));

              case 45:
                _context5.prev = 45;
                // Save the booking into indexedDB, and sync it to backend
                // await saveBooking(BookingModule.selectedBooking);
                saveUntypedBooking(BookingModule.selectedBooking);
                BookingModule.setBookingStep({
                  bookingUUID: BookingModule.selectedBooking.uuid,
                  step: BookingStep.CompleteOrder
                }); // auto print tickets/labels

                if (PrinterConfigModule.hasAutoPrinting) {
                  if (PrinterConfigModule.isTicketPrintingEnabled) {
                    autoPrintTicket();
                  }

                  if (PrinterConfigModule.isLabelPrintingEnabled) {
                    printLabels();
                  }
                } // complete the transaction


                endTransaction(BookingModule.selectedBooking); // complete italy order session and sign it

                _context5.prev = 50;
                AppModule.updatedIsLoading(true);
                _context5.next = 54;
                return startAndCompleteItalyOrder(BookingModule.selectedBooking);

              case 54:
                _context5.next = 59;
                break;

              case 56:
                _context5.prev = 56;
                _context5.t4 = _context5["catch"](50);
                LogService.info("Failed to complete italy order", {
                  error: _context5.t4
                });

              case 59:
                _context5.prev = 59;
                AppModule.updatedIsLoading(false);
                return _context5.finish(59);

              case 62:
                _context5.prev = 62;
                AppModule.updatedIsLoading(true);
                _context5.next = 66;
                return signAustriaReceipt(BookingModule.selectedBooking);

              case 66:
                result = _context5.sent;
                _context5.next = 72;
                break;

              case 69:
                _context5.prev = 69;
                _context5.t5 = _context5["catch"](62);
                LogService.info("Failed to sign austrian receipt", {
                  error: _context5.t5
                });

              case 72:
                _context5.prev = 72;
                AppModule.updatedIsLoading(false);
                return _context5.finish(72);

              case 75:
                _context5.prev = 75;

                if (!BookingModule.currentOrderSessionId) {
                  _context5.next = 80;
                  break;
                }

                AppModule.updatedIsLoading(true);
                _context5.next = 80;
                return processSaleEvent(BookingModule.selectedBooking, BookingModule.currentOrderSessionId);

              case 80:
                _context5.next = 85;
                break;

              case 82:
                _context5.prev = 82;
                _context5.t6 = _context5["catch"](75);
                LogService.info("Sale event processing failed", {
                  error: _context5.t6
                });

              case 85:
                _context5.prev = 85;
                AppModule.updatedIsLoading(false);
                return _context5.finish(85);

              case 88:
                return _context5.abrupt("return");

              case 91:
                _context5.prev = 91;
                _context5.t7 = _context5["catch"](45);
                LogService.info("Error when saving the booking to indexedDB, booking: ".concat(BookingModule.selectedBooking.uuid), {
                  params: {
                    booking: BookingModule.selectedBooking,
                    error: _context5.t7
                  }
                });

              case 94:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[36, 42], [45, 91], [50, 56, 59, 62], [62, 69, 72, 75], [75, 82, 85, 88]]);
      }))();
    },
    goBack: function goBack() {
      var selectedBookingUUID = BookingModule.selectedBookingUUID;
      BookingModule.setBookingStep({
        bookingUUID: selectedBookingUUID,
        step: BookingStep.Order
      });
      return;
    },
    completeCodeAccountings: function completeCodeAccountings() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var bookingCopy, i, isEditOrder;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                // If the booking has generic discount accountings, or discount codes accountings, or payment codes accountings
                // then they are in Pending state and we need to confirm them before moving the booking to backend
                LogService.info("Completing generic discount and applied code accountings of the booking because it will be synched with balance");
                bookingCopy = cloneDeep(BookingModule.selectedBooking);

                for (i = 0; i < bookingCopy.accountings.length; i++) {
                  if (!bookingCopy.accountings[i].refund) {
                    if (bookingCopy.accountings[i].promoCodeId || bookingCopy.accountings[i].promoCodeUuid || bookingCopy.accountings[i].promocode || bookingCopy.accountings[i].transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT) {
                      // So this accounting is of type discount or payment of code applied
                      if (bookingCopy.accountings[i].state === AccountingState.Pending && !bookingCopy.accountings[i].id) {
                        // We complete only the ones that were created by the user recently
                        // for instance, we don't complete the ones coming from backend
                        bookingCopy.accountings[i].state = AccountingState.Completed;
                      }
                    }
                  }
                }

                _context6.next = 5;
                return isBookingInDexie(bookingCopy.uuid);

              case 5:
                isEditOrder = _context6.sent;

                if (!isEditOrder) {
                  // if it has promocode than it was already posted as pending
                  bookingCopy.isToBePartiallySynched = true;
                }

                BookingModule.updateBooking(bookingCopy);

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              console.log("-------------- Booking component mounted"); // BOO-1232: This function is not needed anymore
              // As soon as the cashfloat is created, a new booking gets
              // created.
              // But we could be in a case where the app updates and the organiser
              // will see a blank page. We should create a new booking for the user
              // in this case.

              if (_this4.hasSalesStarted) {
                _this4.fillBooking();
              } // Lets initialize Intercom after page refresh
              // if (process.env.VUE_APP_ENV === "prod") {
              // await initializeIntercomWithoutCompanyData();
              // }


            case 2:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  }
});